module.exports = __webpack_public_path__ + "static/media/01_Citation_Set_preview.51432bd7.png";